import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    try {
      const r = await api.get('/auth/me');
      setUser(r.data);
      setError('');
    } catch (e) {
      setUser(null);
      setError(e.response?.data?.detail || 'Unable to load your ESD access');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refreshMe(); }, [refreshMe]);

  return (
    <AuthContext.Provider value={{ user, error, loading, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export const hasRole = (user, ...roles) => !!user && roles.includes(user.role);
